module.exports = __webpack_public_path__ + "assets/img/solar-panels-9.8ad30e9c.jpg";